import { useState, useRef, useEffect, useCallback, useContext } from "react";
import { KeycloakContext } from "./context";
import "./DiscussionSearch.css";
import { fetchLockbitMessages } from "./api";

const LIMIT = 100;

function DiscussionSearch({ id }) {
  const [messages, setMessages] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const discussionRef = useRef();
  const {userInfos } = useContext(KeycloakContext);

  const fetchMessages = async () => {
    if (isFetching || !id ) return;
    setIsFetching(true);
    try {
      const data = await fetchLockbitMessages(id, userInfos.apiKey);
      setMessages(data.messages);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchMessages(id);
  }, [id]);

  return (
    <div className="blackbasta-container">
      {/* Colonne de gauche - recherche */}
      <div className="search-column"></div>

      {/* Colonne de droite - discussion */}
      <div className="discussion-column" ref={discussionRef}>
        <div className="discussion">
          {messages.map((msg) => (
            <div key={msg.index} className="message-bubble">
              <div className="message-meta">
                <strong>{msg.date}</strong>
              </div>
              <div className="message-content">{msg.content}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DiscussionSearch;
